// TODO (kyle): remove for hot reloading
let currentId = localStorage.currentId ? parseInt(localStorage.currentId) : 0;

export default function uniqueId(prefix: string = ''): string {
  currentId++;
  localStorage.currentId = currentId;
  return prefix + currentId;
}
